export default "__VITE_ASSET__97a636f3__"